import React from "react";

export default function Balances() {
  return (
    <section>
      <h2>Balances Page</h2>
    </section>
  );
}
